import React, {PropTypes} from 'react';
import Fuse from 'fuse.js';
// import { Link } from 'react-router';
import FontAwesome from 'react-fontawesome';

class AdminTable extends React.Component {
  constructor(props, context) {
    super(props, context);
    // this.componentWillMount = this.componentWillMount.bind(this);
    this.filterUpdate = this.filterUpdate.bind(this);
    this.isAdmin = this.isAdmin.bind(this);
    this.state = {
      filter: "",
    };
  }

  filterUpdate(e) {
    let filter = e.target.value;
    this.setState({
      filter: filter
    });
  }

  isAdmin(id) {
    return this.props.checked.indexOf(id) != -1;
  }

  render() {
    let filteredList = this.props.list;
    if(this.state.filter) {
      let search = new Fuse(this.props.list,{
        keys: ["name",]
        });
      filteredList = search.search(this.state.filter);
    }
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="page-header clearfix form-inline">
            <h2>
              {this.props.heading}

              <div className="pull-right">
                <div className="input-group hidden-xs">
                  <span className="input-group-addon" id="basic-addon3">
                    <FontAwesome
                      name="search" />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    onChange={this.filterUpdate}
                    value={this.state.filter}
                    />
                </div>
                {' '}
              </div>
            </h2>
          </div>
          <div className="">
            <div className="hidden-sm hidden-sm hidden-md hidden-lg hidden-xl">
              <div className="input-group">
                <span className="input-group-addon">
                  <FontAwesome
                    name="search" />
                </span>
                <input
                  type="text"
                  className="form-control"
                  onChange={this.filterUpdate}
                  value={this.state.filter}
                  />
              </div>
              <hr/>
            </div>
            <table className="table table-background table-bordered">
              <thead>
                <tr>
                  <th>Navn</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {filteredList.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <h5>{item.name}</h5>
                      </td>
                      <td>
                        <div className="checkbox">
                          <label htmlFor={this.props.listName + '_admin_checkbox_' + index}>
                            <input type="checkbox"
                              value={item.id}
                              checked={this.isAdmin(item.id)}
                              onChange={(e) => {this.props.onChange(e, this.props.listName);}}
                              id={this.props.listName + '_admin_checkbox_' + index}/>
                            {this.isAdmin(item.id) ? 'Tildelt' : 'Ikke tildelt'}
                          </label>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

AdminTable.propTypes = {
  heading: PropTypes.string,
  listName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  list: PropTypes.array.isRequired,
  checked: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};

export default AdminTable;



/** WEBPACK FOOTER **
 ** ./src/components/users/AdminTable.js
 **/